import { Layout } from '@rumblefish/ui/Rumblefish23Theme';
import ReactMarkdown from 'react-markdown';
import Policy from './copy.md';
import {
  StyledPolicyText,
  StyledSection,
  StyledTitle,
  StyledWrapper,
} from './PrivacyPolicy.styles';
import type { PrivacyPolicyProps } from './PrivacyPolicy.types';

export const PrivacyPolicy = ({ blogPosts }: PrivacyPolicyProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <StyledSection width="normal">
        <StyledWrapper>
          <StyledTitle variant="display_sm">Privacy Policy</StyledTitle>
          <StyledPolicyText variant="regular_400">
            <ReactMarkdown>{`${Policy}`}</ReactMarkdown>
          </StyledPolicyText>
        </StyledWrapper>
      </StyledSection>
    </Layout>
  );
};
